export const isPhoneNumber = (value: string) => {
  const regex =
    /^(?:\+?\d{1,3}[-.\s]?)?(?:\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/
  return regex.test(value)
}
